import { Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { useSubscriptionStatus } from "hooks";

import { SHIPPER_UPGRADE_RELATIVE_URL } from "../../../../constants";

export function ShipperTrialDaysRemainingText() {
  const { subscription } = useSubscriptionStatus();

  if (subscription?.subscription_plan !== "SHIPPER_TRIAL") {
    return <div />;
  }

  if (!subscription.is_active) {
    return (
      <Typography variant="h6" color="white" noWrap>
        {"Your trial has ended. "}
        <Link
          component={RouterLink}
          to={SHIPPER_UPGRADE_RELATIVE_URL}
          sx={{ color: "yellow", textDecorationColor: "yellow" }}
        >
          Upgrade now
        </Link>
        {" to continue using Evotrux!"}
      </Typography>
    );
  }

  return (
    <Typography variant="h6" color="white" noWrap>
      {subscription.shipper_trial_detail?.days_remaining} days of your{" "}
      <span style={{ color: "yellow" }}>Premium</span> free trial remain
    </Typography>
  );
}
